/**
 * Session 26 — OCPP 2.0.1 ISO 15118 Plug & Charge outbound (CP → CSMS):
 *   - Get15118EVCertificate — relay the EV's certificate Install/Update
 *     request (EXI) to the CSMS during a PnC session.
 *   - GetCertificateStatus  — ask the CSMS for an OCSP status of a cert.
 * v2.0.1-only; CP-initiated, so adapter methods (no inbound handler).
 */
export interface Get15118EVCertificateDomain {
  readonly iso15118SchemaVersion: string;
  readonly action: 'Install' | 'Update';
  readonly exiRequest: string;
}
export interface Get15118EVCertificateResponse {
  readonly status: string; // Accepted | Failed
  readonly exiResponse: string;
}

export function buildGet15118EVCertificateRequest(
  req: Get15118EVCertificateDomain,
): Record<string, unknown> {
  return {
    iso15118SchemaVersion: req.iso15118SchemaVersion,
    action: req.action,
    exiRequest: req.exiRequest,
  };
}

export function parseGet15118EVCertificateResponse(
  p: Record<string, unknown>,
): Get15118EVCertificateResponse {
  return { status: p['status'] as string, exiResponse: p['exiResponse'] as string };
}

export interface OcspRequestData {
  readonly hashAlgorithm: string;
  readonly issuerNameHash: string;
  readonly issuerKeyHash: string;
  readonly serialNumber: string;
  readonly responderURL: string;
}
export interface GetCertificateStatusDomain {
  readonly ocspRequestData: OcspRequestData;
}
export interface GetCertificateStatusResponse {
  readonly status: string; // Accepted | Failed
  readonly ocspResult?: string;
}

export function buildGetCertificateStatusRequest(
  req: GetCertificateStatusDomain,
): Record<string, unknown> {
  return { ocspRequestData: { ...req.ocspRequestData } };
}

export function parseGetCertificateStatusResponse(
  p: Record<string, unknown>,
): GetCertificateStatusResponse {
  return {
    status: p['status'] as string,
    ...(typeof p['ocspResult'] === 'string' ? { ocspResult: p['ocspResult'] } : {}),
  };
}
